/**
 * @flow
 *
 * @format
 */

export const VALIDITY_SET_ITEM_VALID = 'validity/VALIDITY_SET_ITEM_VALID';
export const VALIDITY_CLEANUP = 'validity/VALIDITY_CLEANUP';
